<template lang="pug">
  div.tabla.sombra
    .mb-2
      b-row(align-h="between")
        b-col(cols="12" md="auto")
          h3.d-inline.mr-3 Tiendas
        b-col(cols="12" md="auto")
          b-button.boton(v-b-modal.create-store-form-modal) Ingresar Nueva
      b-row
        b-col(cols="12" md="auto")
          b-form-input(v-model="filterOptions.search" placeholder="Buscar")
    b-table(:fields="fields" :items="filteredData")
      template(#cell(actions)="{value}")
        b-button.mr-2.mb-1.boton-editar(@click="$router.push(`/tiendas/${value.id}`)")
          .material-icons create
        b-button.mb-1.boton-eliminar(@click="onDeleteUser(value)")
          .material-icons delete_outline
      template(v-slot:cell(name)="{item}")
        .columna {{item.name}}
    //- b-pagination-nav(
    //-   align="center"
    //-   :number-of-pages="totalPages? totalPages : 1"
    //-   :link-gen="linkGen"
    //-   v-model="currentPage"
    //- )
    b-modal#create-store-form-modal(ref="createStoreFormModal" hide-footer title="Creando Tienda")
      store-form(@done="onDoneUserModal")
    b-modal(ref="updateStoreFormModal" hide-footer title="Editando Tienda")
      store-form(@done="onDoneUserModal" :store="selectedStore" :editMode="true")
</template>

<script>
import StoreForm from './StoreForm'
import { mapActions, mapGetters } from 'vuex'
import MakeToastMixin from '../mixins/MakeToastMixin'
import formatterUtils from '../../utils/formatterUtils'

export default {
  mixins: [MakeToastMixin],
  components: {
    StoreForm
  },
  data () {
    return {
      selectedStore: null,
      filterOptions: {
        search: '',
      },
      fields: [
        { label: 'Nombre', key: 'name' },
        { label: 'Activo', key: 'isActive' },
        { label: 'Acciones', key: 'actions' }
      ]
    }
  },
  methods: {
    ...mapActions(['listStore', 'deleteStore']),
    async fetchData () {
      // const response = await this.listStore({ params: { page: this.page, size: this.size } })
      const response = await this.listStore()
      if (response.status === 200) {
        // this.totalPages = response.data.totalPages
      } else if (response.status >= 400 && response.status < 500) {
        this.makeDangerToast(response.data.message || 'Error al cargar tiendas')
      }
    },
    onDoneUserModal () {
      // this.listStore({ params: { page: this.page, size: this.size } })
      this.listStore()
      this.$refs.createStoreFormModal.hide()
      this.$refs.updateStoreFormModal.hide()
    },
    async onDeleteUser (store) {
      const ok = await this.$bvModal.msgBoxConfirm(`¿Está seguro que desea eliminar la tienda ${store.name}?`)
      if (!ok) return

      const response = await this.deleteStore({ id: store.id })
      if (response.status === 200) {
        this.makeSuccessToast('La tienda se eliminó correctamente')
      } else if (response.status >= 400 && response.status < 500) {
        this.makeDangerToast(response.data.message || 'Error al eliminar usuario')
      }
      // await this.listStore({ params: { page: this.page, size: this.size } })
      await this.listStore()
    },
    openEditModal (store) {
      this.selectedStore = store
      this.$refs.updateStoreFormModal.show()
    }
    // linkGen (pageNum) {
    //   return {
    //     path: '/tiendas/',
    //     query: { page: pageNum }
    //   }
    // }
  },
  computed: {
    ...mapGetters(['stores']),
    storeData () {
      return this.stores.reduce((acum, store) => acum.concat({
        name: store.name,
        isActive: store.isActive ? 'SI' : 'NO',
        actions: store,
        serchableText: formatterUtils.cleanStringToFilter(store.name)
      }), [])
    },
    filteredData () {
      if (!this.filterOptions.search) return this.storeData
      return this.storeData.filter(store => store.serchableText.includes(formatterUtils.cleanStringToFilter(this.filterOptions.search)))
    }
  },
  created () {
    // this.listStore({ params: { page: this.page, size: this.size } })
    this.fetchData()
  },
  watch: {
    // currentPage (valor) {
    //   this.page = valor - 1
    //   this.fetchData()
    // }
  }
}
</script>

<style lang="scss" scoped>
.form-control:focus {
  color: #495057;
  background-color: #fff;
  border-color: #869099;
  outline: 0;
  box-shadow: 0 0 0 0.2rem #ced4da;
}
</style>